import { Participant } from '@domain/participant/participant';

export class Group {
  constructor(
    public readonly id: number | undefined,
    public readonly nom: string,
    public readonly description?: string,
    public readonly participants?: Participant[],
  ) {}

  get participantCount(): number {
    return this.participants?.length ?? 0;
  }
}

export interface GroupCreateData {
  nom: string;
  description?: string;
  participantIds: number[];
  dispositifId: number;
}
